import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

const AdvertisingOutlined = forwardRef<SVGSVGElement, BusinessIconImageProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <path d="M17.4082 4.62085H6.59157C4.69079 4.62085 3.1499 6.16174 3.1499 8.06252V12.9792C3.1499 14.88 4.69079 16.4208 6.59157 16.4208H17.4082C19.309 16.4208 20.8499 14.88 20.8499 12.9792V8.06252C20.8499 6.16174 19.309 4.62085 17.4082 4.62085Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.475"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.20195 7.51514C9.46276 7.515 9.69815 7.67364 9.7957 7.91553L11.2674 11.5679C11.2693 11.5723 11.2714 11.577 11.2732 11.5815L11.7049 12.6528C11.8366 12.98 11.6793 13.3517 11.3523 13.4839C11.025 13.6159 10.6523 13.4578 10.5203 13.1304L10.2508 12.4624H8.16093L7.89336 13.1294C7.7618 13.4569 7.38885 13.6163 7.06132 13.4849C6.73398 13.3533 6.57469 12.9812 6.70586 12.6538L8.60918 7.9165L8.65117 7.82959C8.76469 7.63683 8.97357 7.51534 9.20195 7.51514ZM14.4217 7.55225C15.1869 7.55232 15.9136 7.87401 16.4432 8.43408C16.9716 8.9932 17.2625 9.74495 17.2625 10.521C17.2625 11.2969 16.9714 12.0479 16.4432 12.6069C15.9136 13.1671 15.1869 13.4897 14.4217 13.4897H13.1004C12.7478 13.4895 12.4611 13.2036 12.4607 12.8511V8.19189C12.4607 7.83902 12.7476 7.55246 13.1004 7.55225H14.4217ZM13.74 12.2114H14.4217C14.824 12.2114 15.2183 12.0422 15.5145 11.729C15.8116 11.4145 15.9841 10.9804 15.9842 10.521C15.9842 10.0616 15.8117 9.62755 15.5145 9.31299C15.2183 8.99969 14.824 8.83064 14.4217 8.83057H13.74V12.2114ZM8.67461 11.1841H9.73515L9.20293 9.86572L8.67461 11.1841Z" fill="currentColor" />
      <path d="M6.59155 18.8792H17.4082" stroke="currentColor" strokeWidth={strokeWidth ?? "1.475"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);

AdvertisingOutlined.displayName = 'AdvertisingOutlined';

export default AdvertisingOutlined;
